import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import COLORS from '../../../../resources/style/Themes';

const CreateAppMessageModal = ({ show, onHide, onCreate }) => {
  const [content, setContent] = useState('');
  const [url, setUrl] = useState('');
  const [title, setTitle] = useState('');
  const [languageCode, setLanguageCode] = useState('');
  const [name, setName] = useState('');

  const [touched, setTouched] = useState({
    title: false,
    content: false,
    name: false,
    url: false,
    languageCode: false,
  });

  const isFieldEmpty = (value) => !value || value.trim() === '';

  const fieldValues = {
    title,
    content,
    name,
    url,
    languageCode,
  };

  const getFieldError = (field) => {
    if (touched[field] && isFieldEmpty(fieldValues[field])) {
      return 'This field is required';
    }
    return '';
  };

  const handleSubmit = () => {
    setTouched({
      title: true,
      content: true,
      name: true,
      url: true,
      languageCode: true,
    });

    if (
      isFieldEmpty(title) ||
      isFieldEmpty(content) ||
      isFieldEmpty(name) ||
      isFieldEmpty(url) ||
      isFieldEmpty(languageCode)
    ) {
      return;
    }

    const newMessage = {
      message: content,
      url: url,
      name: title,
      header: title,
      language_code: languageCode,
    };

    onCreate(newMessage);
    resetValues();
    onHide();
  };

  const resetValues = () => {
    setContent('');
    setLanguageCode('');
    setName('');
    setUrl('');
    setTitle('');
    setTouched({
      title: false,
      content: false,
      name: false,
      url: false,
      languageCode: false,
    });
  };

  const handleBlur = (field) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
  };

  return (
    <Dialog
      open={show}
      onClose={() => {
        onHide();
        resetValues();
      }}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        sx={{
          backgroundColor: COLORS.SAFEGUARD_BLUE,
          color: COLORS.WHITE,
        }}
      >
        Add New Message
      </DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          margin="normal"
          label="Message Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onBlur={() => handleBlur('title')}
          error={!!getFieldError('title')}
          helperText={getFieldError('title')}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Message Content"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          onBlur={() => handleBlur('content')}
          error={!!getFieldError('content')}
          helperText={getFieldError('content')}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onBlur={() => handleBlur('name')}
          error={!!getFieldError('name')}
          helperText={getFieldError('name')}
          required
        />
        <TextField
          fullWidth
          margin="normal"
          label="URL"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          onBlur={() => handleBlur('url')}
          error={!!getFieldError('url')}
          helperText={getFieldError('url')}
          required
        />
        <FormControl
          fullWidth
          sx={{ mb: 2, mt: 2 }}
          error={touched.languageCode && isFieldEmpty(languageCode)}
        >
          <Select
            value={languageCode}
            onChange={(e) => setLanguageCode(e.target.value)}
            onBlur={() => handleBlur('languageCode')}
            displayEmpty
            inputProps={{ 'aria-label': 'Language Code' }}
          >
            <MenuItem value="" disabled>
              Select Language Code
            </MenuItem>
            <MenuItem value="dan">Danish</MenuItem>
            <MenuItem value="eng">English</MenuItem>
            <MenuItem value="fin">Finnish</MenuItem>
            <MenuItem value="fra">French</MenuItem>
            <MenuItem value="deu">German</MenuItem>
            <MenuItem value="ell">Greek</MenuItem>
            <MenuItem value="nob">Norwegian</MenuItem>
            <MenuItem value="pol">Polish</MenuItem>
            <MenuItem value="por">Portuguese</MenuItem>
            <MenuItem value="spa">Spanish</MenuItem>
            <MenuItem value="swe">Swedish</MenuItem>
          </Select>
          {touched.languageCode && isFieldEmpty(languageCode) && (
            <FormHelperText>Language code is required</FormHelperText>
          )}
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            backgroundColor: COLORS.SAFEGUARD_ORANGE,
            color: COLORS.WHITE,
            '&:hover': {
              backgroundColor: COLORS.SAFEGUARD_ORANGE,
            },
          }}
          onClick={handleSubmit}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateAppMessageModal;
